import { render, staticRenderFns } from "./CrossDataTypeSelection.vue?vue&type=template&id=d927cf7c&"
import script from "./CrossDataTypeSelection.vue?vue&type=script&lang=js&"
export * from "./CrossDataTypeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports